import { DateTime } from "luxon";
import convertDateByTimezone from "./convertDateByTimezone";

let morning: { start: string; end: string }[] = [];
let day:     { start: string; end: string }[] = [];
let night:   { start: string; end: string }[] = [];

const splitTimeSpans = (
    currentTimeSpans: { start: string; end: string }[] | undefined,
    timeZone: string
) => {
    morning = [];
    day = [];
    night = [];

    if (!currentTimeSpans?.length) return;

    const base = convertDateByTimezone(timeZone).startOf("day");

    const t12 = base.set({ hour: 12, minute: 0, second: 0 });
    const t18 = base.set({ hour: 18, minute: 0, second: 0 });

    const ms = (dt: DateTime) => dt.toMillis();

    currentTimeSpans.forEach(({ start, end }) => {
        const [sh, sm, ss] = start.split(":").map(Number);
        const [eh, em, es] = end.split(":").map(Number);

        const startDT = base.set({ hour: sh, minute: sm, second: ss });
        const endDT   = base.set({ hour: eh, minute: em, second: es });

        if (ms(endDT) < ms(startDT)) return;

        if (ms(startDT) < ms(t12) && ms(endDT) <= ms(t12)) {
            morning.push({ start, end });
        } else if (ms(startDT) >= ms(t12) && ms(endDT) <= ms(t18)) {
            day.push({ start, end });
        } else if (ms(startDT) >= ms(t18)) {
            night.push({ start, end });
        } else if (ms(startDT) < ms(t12) && ms(endDT) >= ms(t18)) {
            morning.push({ start, end: "12:00:00" });
            day.push({ start: "12:15:00", end: "17:45:00" });
            night.push({ start: "18:00:00", end });
        } else if (ms(startDT) < ms(t12) && ms(endDT) > ms(t12) && ms(endDT) <= ms(t18)) {
            morning.push({ start, end: "12:00:00" });
            day.push({ start: "12:15:00", end });
        } else if (ms(startDT) >= ms(t12) && ms(startDT) < ms(t18) && ms(endDT) >= ms(t18)) {
            day.push({ start, end: "17:45:00" });
            night.push({ start: "18:00:00", end });
        }
    });
};

export { splitTimeSpans, morning, day, night };
